import PrescriptionInfoContainer from './prescription-info-container';

export default PrescriptionInfoContainer;